import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { columnDateField } from "utils/tables-utils";
import { columnTextField } from "utils/tables-utils";
import { IconButton, Tooltip } from "@material-ui/core";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const getColumnModel = () => [
  columnDateField(
    {
      dataField: "DataRecebimento",
      text: "Criado em",
    },
    true
  ),
  columnTextField(
    {
      dataField: "Periodo",
      text: "Período",
      align: "center",
    },
    true
  ),
  columnDateField(
    {
      dataField: "DataVencimento",
      text: "Vencimento em",
    },
    true
  ),
  columnTextField(
    {
      dataField: "NomeCliente",
      text: "Nome do Cliente",
      align: "center",
    },
    true
  ),
  columnTextField(
    {
      dataField: "Status",
      text: "Status",
      align: "center",
      formatter: (cell) => {
        const backgroundColor =
          cell === "Em processamento" ? "#1d77ff" : "#2dce89";
        const borderColor =
          cell === "Em processamento"
            ? "3px solid #9ac2fd"
            : "3px solid #c4f1de";
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
            }}
          >
            <div
              style={{
                height: 15,
                width: 15,
                backgroundColor: backgroundColor,
                border: borderColor,
                borderRadius: "100%",
              }}
            />
            {cell}
          </div>
        );
      },
    },
    true
  ),
  columnTextField(
    {
      dataField: "Download",
      text: "Download",
      align: "center",
      formatter: (cell, row) => {
        if (row.Status === "Em processamento") {
          return null;
        } else {
          return (
            <Tooltip title="Download do relatório">
              <IconButton onClick={() => {}}>
                <a
                  href={row.Download}
                  target="_blank"
                  style={{ textDecoration: "none", color: "#525f7f" }}
                  rel="noreferrer"
                >
                  <FileDownloadIcon />
                </a>
              </IconButton>
            </Tooltip>
          );
        }
      },
    },
    true
  ),
];

export default function TableRelatorrioPedidos({
  tableData,
  currentPage,
  totalRegisters,
  currentSizePerPage,
  searching,
  onPageChange,
  onSizePerPageChange,
  extraActions,
}) {
  const handlePageChange = (newPage) => {
    onPageChange(newPage);
  };

  const handleSizePerPageChange = (newSizePerPage) => {
    onSizePerPageChange(newSizePerPage);
  };

  return (
    <ToolkitTable
      searched={Boolean(tableData)}
      keyField="IdSolicitacao"
      dataTable={tableData}
      columnModel={getColumnModel()}
      headerTitle={"Relatório de Pedidos"}
      showSearch={false}
      loading={searching}
      pagination={{
        options: [25, 50, 100],
        defaultOption: currentSizePerPage,
        showTotal: true,
        totalSize: totalRegisters,
        page: currentPage,
        onPageChange: handlePageChange,
        sizePerPage: currentSizePerPage,
        onSizePerPageChange: handleSizePerPageChange,
      }}
      notFoundTitle="Sua pesquisa não encontrou nenhum pedido."
      extraActions={extraActions}
    />
  );
}
